import { formatDecimal } from './formatDecimal';

export const formatCurrencyValue = (
  value: number | string | undefined,
  scale: number | undefined,
  currency?: string | undefined,
  currencyClassName?: string
): JSX.Element | string => {
  const numberValue =
    typeof value === 'string' ? parseFloat(value) : value ?? 0;
  const absValue = Math.abs(numberValue);

  const formattedValue = formatDecimal(absValue, scale ?? 0);

  const prefix = numberValue < 0 ? '-' : '';

  if (currencyClassName) {
    return (
      <>
        {prefix}
        {formattedValue}{' '}
        {currency && <span className={currencyClassName}>{currency}</span>}
      </>
    );
  }

  return `${prefix}${formattedValue} ${currency ?? ''}`.trim();
};
